"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var layout_1 = require("../../layout");
var Text_1 = __importDefault(require("../../Text"));
var FeaturedIcon_1 = __importDefault(require("../FeaturedIcon"));
var CloseButton_1 = __importDefault(require("../../buttons/CloseButton"));
var DrawerHeader = function (_a) {
    var icon = _a.icon, title = _a.title, subtitle = _a.subtitle, onRequestClose = _a.onRequestClose;
    return (react_1.jsx(layout_1.Flex, { gap: 16, css: { padding: 24, paddingBottom: 12 } },
        icon ? (react_1.jsx(FeaturedIcon_1.default, { icon: icon, color: "Primary", size: "md", theme: "light-circle-outline" })) : null,
        react_1.jsx(layout_1.Flex, { direction: "column", justifyContent: "center", gap: 4, css: { flex: 1, overflow: 'hidden' } },
            react_1.jsx(Text_1.default.Body, { size: "xl", weight: "semibold", color: style_1.DesignSystemThemeColor.Gray.DARK_4, css: { overflow: 'hidden', textOverflow: 'ellipsis' } }, title),
            subtitle ? (react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.DEFAULT, css: { overflow: 'hidden', textOverflow: 'ellipsis' } }, subtitle)) : null),
        react_1.jsx(CloseButton_1.default, { css: { marginTop: -12, marginRight: -8 }, onClick: onRequestClose })));
};
exports.default = DrawerHeader;
